import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-sm-25 p-lg-30" }
const _hoisted_3 = { class: "table-responsive mb-20" }
const _hoisted_4 = { class: "table align-middle mb-0" }
const _hoisted_5 = { class: "shadow-none lh-1 fw-bold ps-0" }
const _hoisted_6 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_7 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_8 = { class: "shadow-none lh-1 fw-medium text-body-tertiary" }
const _hoisted_9 = { class: "shadow-none lh-1 fw-medium text-body-tertiary" }
const _hoisted_10 = { class: "shadow-none lh-1 fw-medium pe-0" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-body-tertiary" }
const _hoisted_16 = { class: "table-responsive" }
const _hoisted_17 = { class: "table align-middle mb-0" }
const _hoisted_18 = { class: "shadow-none lh-1 fw-bold ps-0" }
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-body-tertiary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
              }, " Code d'envoi "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Status "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Etat "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Commentaire "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Date "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 pe-0"
              }, " Informations "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 pe-0"
              }, " Action par ")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailsColis, (detail, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("th", _hoisted_5, [
                  _createElementVNode("b", null, _toDisplayString(detail.parcel_code), 1)
                ]),
                _createElementVNode("td", _hoisted_6, [
                  (
                    detail.status === 'IN_PROGRESS' &&
                    detail.status_second &&
                    detail.status_second !== null
                  )
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                        style: _normalizeStyle({
                    '--dynamic-bg': _ctx.globalHelper(detail.status_second)
                      .code_color,
                  })
                      }, _toDisplayString(_ctx.globalHelper(detail.status_second).name), 5))
                    : (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                        style: _normalizeStyle({ '--dynamic-bg': detail.code_color })
                      }, _toDisplayString(detail.s_name), 5))
                ]),
                _createElementVNode("td", _hoisted_7, [
                  _createElementVNode("span", {
                    class: _normalizeClass(`badge text-outline-${_ctx.resolveUserStatusVariant(
                    detail.situation
                  )} rounded-pill fs-13`)
                  }, _toDisplayString(_ctx.resolveStatuParcel(detail.situation)), 3)
                ]),
                _createElementVNode("td", _hoisted_8, [
                  _createElementVNode("p", null, _toDisplayString(detail.comment), 1)
                ]),
                _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.getDate(detail.created_at)), 1),
                _createElementVNode("td", _hoisted_10, [
                  _createElementVNode("ul", null, [
                    (detail.city_name)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                          _createElementVNode("span", null, [
                            _cache[0] || (_cache[0] = _createElementVNode("b", null, "Ville: ", -1)),
                            _createTextVNode(" " + _toDisplayString(detail.city_name), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (detail.data)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                          _createElementVNode("span", null, _toDisplayString(detail.data), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (detail.livreur_name && detail.livreur_phone)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                          _createElementVNode("span", null, [
                            _cache[1] || (_cache[1] = _createElementVNode("b", null, "Livreur : ", -1)),
                            _createTextVNode(_toDisplayString(detail.livreur_name) + " ", 1),
                            _cache[2] || (_cache[2] = _createElementVNode("b", null, "/", -1)),
                            _createTextVNode(" " + _toDisplayString(detail.livreur_phone), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (detail.datas && detail.datas.length !== 0)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.datas, (data, index) => {
                            return (_openBlock(), _createElementBlock("ul", {
                              key: index,
                              style: {"list-style-type":"circle"}
                            }, [
                              _createElementVNode("li", null, [
                                _createTextVNode(_toDisplayString(data.data) + " (", 1),
                                _createElementVNode("b", null, _toDisplayString(_ctx.getDate(data.created_at)), 1),
                                _cache[3] || (_cache[3] = _createTextVNode(") ", -1))
                              ])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("td", _hoisted_15, _toDisplayString(detail.history_by_name), 1)
              ]))
            }), 128))
          ])
        ])
      ]),
      _cache[9] || (_cache[9] = _createElementVNode("hr", null, null, -1)),
      _cache[10] || (_cache[10] = _createElementVNode("h6", { class: "card-title fw-bold mb-20" }, "Historique d'appel", -1)),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("table", _hoisted_17, [
          _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
              }, " Code d'envoi "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Appelé par "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Date ")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailsCalls, (item, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("th", _hoisted_18, [
                  _createElementVNode("b", null, _toDisplayString(item.parcel_code), 1)
                ]),
                _createElementVNode("td", _hoisted_19, [
                  _cache[5] || (_cache[5] = _createElementVNode("b", null, "Livreur:", -1)),
                  _createTextVNode(" " + _toDisplayString(item.user_name), 1),
                  _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                  _cache[7] || (_cache[7] = _createElementVNode("b", null, "Téléphone:", -1)),
                  _createTextVNode(_toDisplayString(item.phone), 1)
                ]),
                _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.getDate(item.created_at)), 1)
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}